import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../../../utils/cn';
import { useLanguage } from '../../../contexts/LanguageContext';

export const NAV_ITEMS = [
  { path: '/', labelKey: 'nav.home' },
  { path: '/services', labelKey: 'nav.services' },
  { path: '/about', labelKey: 'nav.about' },
  { path: '/contact', labelKey: 'nav.contact' },
];

/**
 * Desktop navigation links component
 */
export const NavLinks = () => {
  const location = useLocation();
  const { t } = useLanguage();

  return (
    <ul className="flex gap-4 lg:gap-6 justify-center" role="menubar" aria-label="Site navigasyonu">
      {NAV_ITEMS.map(({ path, labelKey }) => (
        <li key={path} role="none">
          <Link
            to={path}
            className={cn(
              'relative py-1 text-sm font-semibold tracking-wide transition-colors duration-300',
              location.pathname === path ? 'text-primary' : 'text-gray-600 hover:text-primary',
              'after:content-[""] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-primary after:scale-x-0 after:origin-right after:transition-transform after:duration-300 hover:after:scale-x-100 hover:after:origin-left',
              location.pathname === path && 'after:scale-x-100 after:origin-left'
            )}
            role="menuitem"
            aria-current={location.pathname === path ? 'page' : undefined}
          >
            {t(labelKey).toUpperCase()}
          </Link>
        </li>
      ))}
    </ul>
  );
};
